import * as Config from "@/config";
import { RenderRow } from "@/containers/data/Attributes/AttributeInput";
import * as Common from "@/utils/common";
import React from "react";

interface PidInputRowsProps {
  isType: Config.Data;
  attributes: Array<any>;
}

const PidInputRows: React.FC<PidInputRowsProps> = ({ isType, attributes }) => {
  const attr = attributes.find((attr) => Common.isPId(attr));
  return <RenderRow isType={isType} attr={attr} />;
};

export default PidInputRows;
